import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { orderBy as sort } from "lodash";

import { HydrovacTicket } from "../interface/api/HydrovacTicket";
import { HydrovacTicketState } from "../interface/redux-types/HydrovacTicketState";
import { RootState } from "..";

const initialState: HydrovacTicketState = {
  tickets: [],
  ticket: null,
  pendingHeadspace: [],
};

const slice = createSlice({
  name: "hydrovacTicket",
  initialState,
  reducers: {
    setHydrovacTickets: (
      state,
      action: PayloadAction<{ tickets: HydrovacTicket[] }>
    ) => {
      state.tickets = action.payload.tickets;
    },
    setHydrovacTicket: (
      state,
      action: PayloadAction<{ ticket: HydrovacTicket | null }>
    ) => {
      state.ticket = action.payload.ticket;
    },
    setHydrovacPendingHeadspace: (
      state,
      action: PayloadAction<{ tickets: HydrovacTicket[] }>
    ) => {
      state.pendingHeadspace = action.payload.tickets;
    },
    updateHydrovacTicketInList: (
      state,
      action: PayloadAction<{ ticket: HydrovacTicket }>
    ) => {
      const { ticket } = action.payload;
      const index = state.tickets.findIndex((t) => t.id === ticket.id);
      if (index >= 0) {
        state.tickets[index] = ticket;
      }
    },
  },
});

export const {
  setHydrovacTickets,
  setHydrovacTicket,
  setHydrovacPendingHeadspace,
  updateHydrovacTicketInList,
} = slice.actions;

export const getHydrovacTickets = createSelector(
  (state: RootState) => state.hydrovacTicketStore?.tickets ?? [],
  (tickets) => sort(tickets, ["ticketNumber"], ["desc"])
);

export const getHydrovacTicket = createSelector(
  (state: RootState) => state.hydrovacTicketStore?.ticket ?? null,
  (ticket) => ticket
);

export const getHydrovacPendingHeadspace = createSelector(
  (state: RootState) => state.hydrovacTicketStore?.pendingHeadspace ?? [],
  (tickets) => sort(tickets, ["ticketNumber"], ["desc"])
);

export const reducer = slice.reducer;
